/* eslint-disable react-hooks/exhaustive-deps */
import "./style.css";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    LC_API: any; // Hoặc bạn có thể khai báo kiểu cụ thể nếu biết
  }
}

function ChatsPage() {
  return (
    <div>
      <iframe
        style={{
          width: "100vw",
          height: "calc(100vh - 80px)",
          overflow: "hidden",
        }}
        title="My iframe"
        src={"https://tawk.to/chat/66cc176550c10f7a00a0676b/1i66jmppo"}
      />
      {/* <LiveChatWidget
        license="18634758"
        visibility="maximized"
        customerName={profile?.username}
        customerEmail={profile?.email}
        onVisibilityChanged={() => {
          if (window.LC_API) {
            window.LC_API.open_chat_window(); // Mở cửa sổ chat
          }
        }}
      /> */}
    </div>
  );
}

export default ChatsPage;
